"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./DateTimeInput.css");

var _Years = _interopRequireDefault(require("./Picker/Years"));

var _Months = _interopRequireDefault(require("./Picker/Months"));

var _Days = _interopRequireDefault(require("./Picker/Days"));

var _Hours = _interopRequireDefault(require("./Picker/Hours"));

var _Minutes = _interopRequireDefault(require("./Picker/Minutes"));

var _jalaaliJs = _interopRequireDefault(require("jalaali-js"));

var _dateUtils = require("./dateUtils");

var _reactDom = require("react-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var modalRoot = null;

var DatePicker = /*#__PURE__*/function (_Component) {
  _inherits(DatePicker, _Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _divRef$current, _document;

    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (document && document.body && document.body.style) document.body.style.overflow = 'hidden';
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (document && document.body && document.body.style) document.body.style.overflow = '';
    });

    _defineProperty(_assertThisInitialized(_this), "cancelPicker", function (e) {
      e.preventDefault();

      if (_this.props.onDismiss) {
        _this.props.onDismiss();
      }

      _this.props.cancelHandler();
    });

    _defineProperty(_assertThisInitialized(_this), "daysClicked", function (dayDate) {
      if ((0, _dateUtils.isNotEqualDate)(_this.state.selectedDay, dayDate)) {
        var newDate;

        if (_this.props.pickTime) {
          var _this$state = _this.state,
              selectedHour = _this$state.selectedHour,
              selectedMinute = _this$state.selectedMinute;
          newDate = new Date(dayDate.getTime());
          newDate.setHours(selectedHour);
          newDate.setMinutes(selectedMinute);
        } else {
          newDate = new Date(Date.UTC(dayDate.getFullYear(), dayDate.getMonth(), dayDate.getDate(), 0, 0));
        }

        _this.setState({
          selectedDay: newDate
        }, _this.fireChange);
      } else {
        _this.props.cancelHandler();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fireChange", function () {
      _this.props.onChange({
        target: {
          name: _this.props.name,
          value: _this.state.selectedDay
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "monthsClicked", function (month) {
      var _this$state2 = _this.state,
          selectedYear = _this$state2.selectedYear,
          gregorian = _this$state2.gregorian;
      var currentMonth, daysCount, selectedMonthFirstDay;

      if (month === 0) {
        currentMonth = 12;
        selectedYear = selectedYear - 1;
      } else if (month === 13) {
        currentMonth = 1;
        selectedYear = selectedYear + 1;
      } else {
        currentMonth = month;
      }

      daysCount = gregorian ? (0, _dateUtils.gregorianMonthLength)(selectedYear, currentMonth) : _jalaaliJs.default.jalaaliMonthLength(selectedYear, currentMonth);
      selectedMonthFirstDay = (0, _dateUtils.calcFirstDayOfMonth)(selectedYear, currentMonth, gregorian);

      _this.setState({
        currentMonth: currentMonth,
        daysCount: daysCount,
        selectedYear: selectedYear,
        selectedMonthFirstDay: selectedMonthFirstDay
      });
    });

    _defineProperty(_assertThisInitialized(_this), "yearSelected", function (selectedYear) {
      var selectedMonthFirstDay, daysCount;
      selectedMonthFirstDay = (0, _dateUtils.calcFirstDayOfMonth)(selectedYear, _this.state.currentMonth, _this.state.gregorian);
      daysCount = _this.state.gregorian ? (0, _dateUtils.gregorianMonthLength)(selectedYear, _this.state.currentMonth) : _jalaaliJs.default.jalaaliMonthLength(selectedYear, _this.state.currentMonth);

      _this.setState({
        selectedYear: selectedYear,
        selectedMonthFirstDay: selectedMonthFirstDay,
        daysCount: daysCount
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hourSelected", function (selectedHour) {
      var selectedDay = _this.state.selectedDay;

      if (selectedDay) {
        selectedDay.setHours(selectedHour);
      }

      _this.setState({
        selectedDay: selectedDay,
        selectedHour: selectedHour
      }, _this.fireChange);
    });

    _defineProperty(_assertThisInitialized(_this), "minuteSelected", function (selectedMinute) {
      var selectedDay = _this.state.selectedDay;

      if (selectedDay) {
        selectedDay.setMinutes(selectedMinute);
      }

      _this.setState({
        selectedDay: selectedDay,
        selectedMinute: selectedMinute
      }, _this.fireChange);
    });

    _defineProperty(_assertThisInitialized(_this), "gregorianPicker", function () {
      var gregorian = !_this.state.gregorian;
      var selectedDay = _this.state.selectedDay;
      var currentMonth, daysCount, selectedYear, selectedMonthFirstDay;

      if (gregorian) {
        var j = selectedDay ? selectedDay : new Date();
        selectedYear = j.getFullYear();
        currentMonth = j.getMonth() + 1;
      } else {
        var _j = _jalaaliJs.default.toJalaali(selectedDay ? selectedDay : new Date());

        selectedYear = _j.jy;
        currentMonth = _j.jm;
      }

      daysCount = gregorian ? (0, _dateUtils.gregorianMonthLength)(selectedYear, currentMonth) : _jalaaliJs.default.jalaaliMonthLength(selectedYear, currentMonth);
      selectedMonthFirstDay = (0, _dateUtils.calcFirstDayOfMonth)(selectedYear, currentMonth, gregorian);

      _this.setState({
        gregorian: gregorian,
        currentMonth: currentMonth,
        daysCount: daysCount,
        selectedYear: selectedYear,
        selectedMonthFirstDay: selectedMonthFirstDay
      });
    });

    if (!modalRoot) {
      modalRoot = document.createElement('div'); // modalRoot.className = 'JDialogModal';

      document.body.appendChild(modalRoot);
    }

    var _gregorian = props.gregorian,
        _selectedDay = props.selectedDay,
        _props$pickTime = props.pickTime,
        pickTime = _props$pickTime === void 0 ? false : _props$pickTime,
        style = props.style,
        ltr = props.ltr,
        divRef = props.divRef;
    var currentDay = _selectedDay;

    if (!currentDay) {
      currentDay = new Date();
    } else {
      currentDay = new Date(currentDay.getTime());
    }

    if (!pickTime) {
      currentDay.setHours(0);
      currentDay.setMinutes(0);
    } // currentDay.setSeconds(0);


    var _selectedYear, _currentMonth, _selectedMonthFirstDay, _daysCount, _selectedHour, _selectedMinute;

    if (_gregorian) {
      var j = currentDay;
      _selectedYear = j.getFullYear();
      _currentMonth = j.getMonth() + 1;
    } else {
      var _j2 = _jalaaliJs.default.toJalaali(currentDay);

      _selectedYear = _j2.jy;
      _currentMonth = _j2.jm;
    }

    _daysCount = _gregorian ? (0, _dateUtils.gregorianMonthLength)(_selectedYear, _currentMonth) : _jalaaliJs.default.jalaaliMonthLength(_selectedYear, _currentMonth);
    _selectedMonthFirstDay = (0, _dateUtils.calcFirstDayOfMonth)(_selectedYear, _currentMonth, _gregorian);
    _selectedHour = currentDay.getHours();
    _selectedMinute = currentDay.getMinutes(); // console.log({selectedDay})

    var myStyle = style;

    if (divRef !== null && divRef !== void 0 && (_divRef$current = divRef.current) !== null && _divRef$current !== void 0 && _divRef$current.getBoundingClientRect && (_document = document) !== null && _document !== void 0 && _document.documentElement) {
      var rect = divRef.current.getBoundingClientRect();
      var ww = document.documentElement.clientWidth;
      var wh = document.documentElement.clientHeight;
      var dialogHeight = pickTime ? 435 : 330;
      var dialogWidth = 320;
      myStyle = _objectSpread(_objectSpread({}, style), {}, {
        // position: 'fixed',
        top: rect.top + rect.height + 5
      });
      if (myStyle.top < 10) myStyle.top = 10;
      if (myStyle.top + dialogHeight > wh) myStyle.top = wh - dialogHeight; // const wh = (window.innerHeight || document.documentElement.clientHeight);
      // const ww = (window.innerWidth || document.documentElement.clientWidth);
      // debugger;

      if (ltr) {
        myStyle.left = rect.left;
        myStyle.right = 'unset';
        if (myStyle.left < 10) myStyle.left = 10;
        if (myStyle.left + dialogWidth > ww) myStyle.left = ww - dialogWidth;
      } else {
        myStyle.left = 'unset';
        myStyle.right = ww - rect.right;
        if (myStyle.right < 10) myStyle.right = 10;
        if (myStyle.right + dialogWidth > ww) myStyle.right = ww - dialogWidth;
      }
    }

    _this.state = {
      gregorian: _gregorian,
      selectedYear: _selectedYear,
      currentMonth: _currentMonth,
      selectedMonthFirstDay: _selectedMonthFirstDay,
      daysCount: _daysCount,
      selectedDay: _selectedDay ? _selectedDay : null,
      selectedHour: _selectedHour,
      selectedMinute: _selectedMinute,
      style: myStyle
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          _this$props$closeLabe = _this$props.closeLabel,
          closeLabel = _this$props$closeLabe === void 0 ? 'بستن' : _this$props$closeLabe,
          filterDate = _this$props.filterDate,
          ltr = _this$props.ltr,
          _this$props$pickTime = _this$props.pickTime,
          pickTime = _this$props$pickTime === void 0 ? false : _this$props$pickTime;
      var _this$state3 = this.state,
          gregorian = _this$state3.gregorian,
          daysCount = _this$state3.daysCount,
          selectedDay = _this$state3.selectedDay,
          currentMonth = _this$state3.currentMonth,
          selectedYear = _this$state3.selectedYear,
          selectedMonthFirstDay = _this$state3.selectedMonthFirstDay,
          selectedHour = _this$state3.selectedHour,
          selectedMinute = _this$state3.selectedMinute,
          style = _this$state3.style;
      return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: 'OutSideClick',
        onClick: this.cancelPicker
      }, " "), /*#__PURE__*/_react.default.createElement("div", {
        className: "JDatePicker".concat(ltr ? ' ltr' : '', " ").concat(className ? className : ''),
        style: style,
        onClick: function onClick(e) {
          e.preventDefault();
        }
      }, /*#__PURE__*/_react.default.createElement(_Years.default, {
        gregorian: gregorian,
        changeEvent: function changeEvent(returnedYear) {
          return _this2.yearSelected(returnedYear);
        },
        year: selectedYear
      }), /*#__PURE__*/_react.default.createElement(_Months.default, {
        gregorian: gregorian,
        clickEvent: function clickEvent(returnedMonth) {
          return _this2.monthsClicked(returnedMonth);
        },
        month: currentMonth
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "days-titles"
      }, /*#__PURE__*/_react.default.createElement("div", null, "\u0634"), /*#__PURE__*/_react.default.createElement("div", null, "\u06CC"), /*#__PURE__*/_react.default.createElement("div", null, "\u062F"), /*#__PURE__*/_react.default.createElement("div", null, "\u0633"), /*#__PURE__*/_react.default.createElement("div", null, "\u0686"), /*#__PURE__*/_react.default.createElement("div", null, "\u067E"), /*#__PURE__*/_react.default.createElement("div", null, "\u062C")), /*#__PURE__*/_react.default.createElement(_Days.default, {
        gregorian: gregorian,
        selectedYear: selectedYear,
        selectedDay: selectedDay,
        currentMonth: currentMonth,
        daysCount: daysCount,
        firstDay: selectedMonthFirstDay,
        clickEvent: this.daysClicked,
        filterDate: filterDate
      }), pickTime && /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Clock"
      }, /*#__PURE__*/_react.default.createElement(_Hours.default, {
        changeEvent: function changeEvent(returnedHour) {
          return _this2.hourSelected(returnedHour);
        },
        hour: selectedHour
      }), "\xA0:\xA0", /*#__PURE__*/_react.default.createElement(_Minutes.default, {
        changeEvent: function changeEvent(returnedMinute) {
          return _this2.minuteSelected(returnedMinute);
        },
        minute: selectedMinute
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Buttons"
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.cancelPicker
      }, closeLabel), !gregorian && /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.gregorianPicker
      }, 'میلادی'), gregorian && /*#__PURE__*/_react.default.createElement("button", {
        onClick: this.gregorianPicker
      }, 'شمسی')))), modalRoot);
    }
  }]);

  return DatePicker;
}(_react.Component);

var _default = DatePicker;
exports.default = _default;